module.exports = __webpack_public_path__ + "img/header-weddingRingsCarbon@2x.a1c3304.webp";